module.exports = __webpack_public_path__ + "static/visualc3-s-c3be69754b016e5a7af8c4b98f78c8dc.jpg";